/* eslint-disable import/no-mutable-exports */
import AddToClausesListBtn from "./AddToClausesListBtn";

export default AddToClausesListBtn;



// WEBPACK FOOTER //
// ./src/components/DocumentItems/AddToClausesListBtn/index.js